
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
  }
})

export default class ConfirmDialog extends Vue {
  @Prop({ required: true, default: false })
  private dialog!: boolean;

  @Prop({ required: true, default: null })
  private title!: string;

  @Prop({ default: null })
  private text!: string;

  @Prop({ default: null })
  private component!: any;

  @Prop({ default: false })
  private validation!: boolean;

  @Prop({ required: true, default: null })
  private abortButtonText!: string;

  @Prop({ required: true, default: null })
  private confirmButtonText!: string;
}
